"use client"
import useMount from "react-use/lib/useMount";
import styles from './portfolio.module.css';
import wrappers from "components/_styled/wrappers.module.css"
import Categories from "./Categories";
import logPageView from "lib/ga/pageView";
import logPortfolioPageView from "lib/ga/portfolioPageView";
import { portfolioLogosToShrink } from "config/app.config";

type props = {
  portfolio: {
    data: {
      description: string,
      dark: string,
      main: string
    },
    uri: string,
    name: string,
    id: string,
    propertyCategories: object,
    schemeCategories: object
  }
}

const Portfolio = ({ portfolio }: props) => {
  const activePortfolio = portfolio;
  useMount(() => {
    logPageView({ url: window.location.pathname + window.location.search });
    logPortfolioPageView({ portfolio_id: activePortfolio.id });
  });
  const descriptionSplit = activePortfolio.data.description ? activePortfolio.data.description.split("\n") : null;
  const heroBase = process.env.NEXT_PUBLIC_APP_CDN_URL
  // Temporary hack to load images locally for previewing new images
  // const heroBase = '/images/'
  return (
      <div className={styles.FluidWrapper}>
        <div className={styles.Banner} style={{backgroundColor: activePortfolio.data.dark ? activePortfolio.data.dark : '#F2F2F2', color : activePortfolio.data.dark ? "#ffffff" : "initial" }}>
          <div className={wrappers.WrapperTemplate}>
            <div className={wrappers.Row}>
                <div
                  className={styles.LogoLink}
                  style={{
                    backgroundImage: `url(/images/portfolios/${activePortfolio.uri.toLowerCase()}/logo.svg)`,
                    backgroundSize: portfolioLogosToShrink.indexOf(activePortfolio.uri) > -1 ? "80%" : "contain",
                    backgroundPosition: '50% 50%',
                    backgroundRepeat: 'no-repeat'
                  }}
                />

              <div className={styles.Title}>
                <h1>Portfolio | {activePortfolio.name}</h1>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.Hero} style={{borderBottom: activePortfolio.data.main ? `9px solid ${activePortfolio.data.main}` : "9px solid transparent"}}>
            <div className={styles.HeroBox}>
              <picture>
                <source
                  srcSet={`${heroBase}portfolios/${activePortfolio.uri.toLowerCase()}/hero-600.webp 600w, ${heroBase}portfolios/${activePortfolio.uri.toLowerCase()}/hero-800.webp 800w, ${heroBase}portfolios/${activePortfolio.uri.toLowerCase()}/hero-1000.webp 1000w, ${heroBase}portfolios/${activePortfolio.uri.toLowerCase()}/hero-1200.webp 1200w`}
                  type="image/webp"
                />
                <source
                  srcSet={`${heroBase}portfolios/${activePortfolio.uri.toLowerCase()}/hero-600.jpg 600w, ${heroBase}portfolios/${activePortfolio.uri.toLowerCase()}/hero-800.jpg 800w, ${heroBase}portfolios/${activePortfolio.uri.toLowerCase()}/hero-1000.jpg 1000w, ${heroBase}portfolios/${activePortfolio.uri.toLowerCase()}/hero-1200.jpg 1200w`}
                  type="image/jpg"
                />
                <img
                  src={`${heroBase}portfolios/${activePortfolio.uri.toLowerCase()}/hero-600.jpg`}
                  alt={`${activePortfolio.name}'s portfolio`}
                />
              </picture>
            </div>
        </div>

        {descriptionSplit && (
          <div className={styles.Text}>
            <div className={styles.Lead}>
              {activePortfolio.uri === "BritishLand" && descriptionSplit[0] === "" ? (
                <p>
                  We focus on Regional and Local multi-let assets to create outstanding places for modern consumer
                  lifestyles.
                </p>
              ) : (
                <p>{descriptionSplit[0]}</p>
              )}
            </div>
            <div className={styles.Body}>
              {descriptionSplit.map((value, index) => {
                if (index !== 0) return <p key={index}>{value}</p>;
                else return null;
              })}
            </div>
          </div>
        )}

       <Categories activePortfolio={activePortfolio} />
      </div>

  );
};

export default Portfolio;
